import { Link } from "react-router-dom";

function Downloads() {
  return (
   <main id="main">

  <div className="page-header">
    <svg viewBox="0 0 100 100" className="page-header__seal" aria-hidden="true" style={{color:'#fff'}}>
      <circle cx="50" cy="50" r="47" fill="none" stroke="currentColor" strokeWidth="0.8"/>
      <path id="sealTopB" d="M 14,50 A 36,36 0 1,1 86,50" fill="none"/>
      <text fontSize="5.4" letterSpacing="1.5" fill="currentColor"><textPath href="#sealTopB" startOffset="50%" textAnchor="middle">JUSTICE FOR ALL</textPath></text>
    </svg>
    <div className="container">
      <div className="breadcrumb"><Link to="/">Home</Link> / Downloads</div>
      <h1>Downloads</h1>
      <p>Acts, rules, application forms and annual reports published by the Authority. Documents marked verified bear the official registry stamp.</p>
    </div>
  </div>

  <section className="section">
    <div className="container">

      <div className="download-group">
        <div className="download-group__head">
          <h2>Acts &amp; Rules</h2>
          <span className="download-group__count">3 documents</span>
        </div>

        <div className="download-row">
          <svg className="download-row__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3"><path d="M7 3h7l3 3v15H7V3z"/><path d="M14 3v3h3"/><path d="M9.5 11h5M9.5 14h5M9.5 17h3"/></svg>
          <div className="download-row__main">
            <h4>Legal Aid and Justice Authority Act (as amended 2025)</h4>
            <div className="download-row__meta"><span>PDF</span><span>259 KB</span><span>Updated 12 Jan 2025</span></div>
          </div>
          <span className="download-row__stamp">Verified</span>
          <Link to="/images/laja-act-2020.pdf"  target="_blank" rel="noopener noreferrer" className="btn btn--outline-navy btn--sm">Download</Link>
        </div>

        <div className="download-row">
          <svg className="download-row__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3"><path d="M7 3h7l3 3v15H7V3z"/><path d="M14 3v3h3"/><path d="M9.5 11h5M9.5 14h5M9.5 17h3"/></svg>
          <div className="download-row__main">
            <h4>Legal Aid and Justice Authority Rules, 2025</h4>
            <div className="download-row__meta"><span>PDF</span><span>617 KB</span><span>Updated 18 Jun 2026</span></div>
          </div>
          <span className="download-row__stamp">Verified</span>
          <Link to="/images/laja_rules.pdf"  target="_blank" rel="noopener noreferrer"  className="btn btn--outline-navy btn--sm">Download</Link>
        </div>

        <div className="download-row">
          <svg className="download-row__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3"><path d="M7 3h7l3 3v15H7V3z"/><path d="M14 3v3h3"/><path d="M9.5 11h5M9.5 14h5M9.5 17h3"/></svg>
          <div className="download-row__main">
            <h4>Legal Aid and Justice Authority Act, 2020</h4>
            <div className="download-row__meta"><span>PDF</span><span>259 KB</span><span>Updated 3 July 2020</span></div>
          </div>
          <span className="download-row__stamp">Verified</span>
          <Link to="/images/laja-act-2020.pdf"  target="_blank" rel="noopener noreferrer" className="btn btn--outline-navy btn--sm">Download</Link>
        </div>
      </div>

      <div className="download-group">
        <div className="download-group__head">
          <h2>Application &amp; Complaint Forms</h2>
          <span className="download-group__count">3 documents</span>
        </div>

        <div className="download-row">
          <svg className="download-row__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3"><path d="M4 4h16v16H4z"/><path d="M8 9h8M8 13h8M8 17h5"/></svg>
          <div className="download-row__main">
            <h4>Form for Free Legal Aid (Power of Attorney)</h4>
            <div className="download-row__meta"><span>DOCX</span><span>140 KB</span></div>
          </div>
          <span className="download-row__stamp">Verified</span>
          <Link to="/images/poa.pdf" target="_blank" rel="noopener noreferrer" className="btn btn--outline-navy btn--sm">Download</Link>
        </div>

        <div className="download-row">
          <svg className="download-row__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3"><path d="M4 4h16v16H4z"/><path d="M8 9h8M8 13h8M8 17h5"/></svg>
          <div className="download-row__main">
            <h4>Public Grievance / Contact us (Online Form)</h4>
            <div className="download-row__meta"><span>HTML</span><span>308 KB</span></div>
          </div>
          <span className="download-row__stamp">Verified</span>
          <Link to="/contact" className="btn btn--outline-navy btn--sm">Fill Online</Link>
        </div>

        <div className="download-row">
          <svg className="download-row__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3"><path d="M4 4h16v16H4z"/><path d="M8 9h8M8 13h8M8 17h5"/></svg>
          <div className="download-row__main">
            <h4>Legal Aid Application (Online Form)</h4>
            <div className="download-row__meta"><span>HTML</span><span>390 KB</span></div>
          </div>
          <span className="download-row__stamp">Verified</span>
          <Link to="/application" className="btn btn--outline-navy btn--sm">Fill Online</Link>
        </div>

        {/* <div className="download-row">
          <svg className="download-row__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3"><path d="M4 4h16v16H4z"/><path d="M8 9h8M8 13h8M8 17h5"/></svg>
          <div className="download-row__main">
            <h4>Victim Compensation Claim Form (Form VC-3)</h4>
            <div className="download-row__meta"><span>PDF</span><span>305 KB</span></div>
          </div>
          <span className="download-row__stamp">Verified</span>
          <Link to="" className="btn btn--outline-navy btn--sm">Download</Link>
        </div> */}
{/* 
        <div className="download-row">
          <svg className="download-row__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3"><path d="M4 4h16v16H4z"/><path d="M8 9h8M8 13h8M8 17h5"/></svg>
          <div className="download-row__main">
            <h4>Advocate Empanelment Application</h4>
            <div className="download-row__meta"><span>DOCX</span><span>98 KB</span></div>
          </div>
          <span className="download-row__stamp">Verified</span>
          <Link to="" className="btn btn--outline-navy btn--sm">Download</Link>
        </div> */}
      </div>

      {/* <div className="download-group">
        <div className="download-group__head">
          <h2>Annual Reports</h2>
          <span className="download-group__count">3 documents</span>
        </div>

        <div className="download-row">
          <svg className="download-row__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3"><path d="M5 4h11l3 3v13H5z"/><path d="M9 12l2 2 4-5"/></svg>
          <div className="download-row__main">
            <h4>Annual Report 2025&ndash;26</h4>
            <div className="download-row__meta"><span>PDF</span><span>6.4 MB</span><span>Published Apr 2026</span></div>
          </div>
          <span className="download-row__stamp">Verified</span>
          <Link to="" className="btn btn--outline-navy btn--sm">Download</Link>
        </div>
      
      </div> */}

    </div>
  </section>

</main>
  );
}

export default Downloads;
